export default __webpack_public_path__ + "1cda9a9c83140b6dbabe7d27656f1d72.png";